import React from 'react';
import { CheckCircle } from 'lucide-react';

interface ServiceProps {
  service: {
    icon: React.ReactNode;
    title: string;
    description: string;
    features: string[];
  };
}

const ServiceCard: React.FC<ServiceProps> = ({ service }) => {
  return (
    <div className="group relative bg-gradient-to-b from-slate-800 to-slate-900 rounded-xl p-6 border border-slate-700/50 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-blue-500/5 to-teal-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
      
      <div className="mb-4">{service.icon}</div>
      
      <h3 className="text-xl font-bold text-white mb-3">{service.title}</h3>
      
      <p className="text-slate-300 mb-6">{service.description}</p>
      
      <ul className="space-y-2">
        {service.features.map((feature, index) => (
          <li key={index} className="flex items-start gap-2">
            <CheckCircle className="w-5 h-5 text-teal-400 mt-0.5 flex-shrink-0" />
            <span className="text-slate-300">{feature}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ServiceCard;